export default __webpack_public_path__ + "static/media/s-row-img.ed514618.png";